// Tiny fetch wrapper that always sends/receives JSON and forwards
// the admin session cookie. Same-origin requests => no host needed.

async function request(url, opts = {}) {
  const res = await fetch(url, {
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      ...(opts.headers || {})
    },
    ...opts,
    body: opts.body && typeof opts.body !== "string"
      ? JSON.stringify(opts.body)
      : opts.body
  });
  const text = await res.text();
  let data;
  try { data = text ? JSON.parse(text) : null; } catch (e) { data = text; }
  if (!res.ok) {
    const err = new Error((data && data.error) || res.statusText);
    err.status = res.status;
    err.data = data;
    throw err;
  }
  return data;
}

// ── Public ──────────────────────────────────────────────────────
export const getContent = () => request("/api/content");
export const submitContact = (payload) =>
  request("/api/contact", { method: "POST", body: payload });

// ── Admin auth ──────────────────────────────────────────────────
export const adminLogin = (email, password) =>
  request("/api/admin/login", { method: "POST", body: { email, password } });
export const adminLogout = () =>
  request("/api/admin/logout", { method: "POST" });
export const adminMe = () => request("/api/admin/me");

// ── Admin content ───────────────────────────────────────────────
export const adminGetContent = () => request("/api/admin/content");
export const adminPatchContent = (patch) =>
  request("/api/admin/content", { method: "PATCH", body: patch });
export const adminPutSection = (section, value) =>
  request(`/api/admin/section/${section}`, { method: "PUT", body: value });

// ── Admin lists (services / projects / testimonials / heroSlides / stats / featuredLogos) ──
export const adminListAdd = (section, item) =>
  request(`/api/admin/list/${section}`, { method: "POST", body: item });
export const adminListUpdate = (section, id, item) =>
  request(`/api/admin/list/${section}/${id}`, { method: "PUT", body: item });
export const adminListDelete = (section, id) =>
  request(`/api/admin/list/${section}/${id}`, { method: "DELETE" });

// ── Image upload ────────────────────────────────────────────────
export async function adminUploadImage(file) {
  const fd = new FormData();
  fd.append("image", file);
  const res = await fetch("/api/admin/upload", {
    method: "POST",
    credentials: "include",
    body: fd
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || "Upload failed");
  return data;
}

// ── PDF upload ──────────────────────────────────────────────────
export async function adminUploadPdf(file) {
  const fd = new FormData();
  fd.append("pdf", file);
  const res = await fetch("/api/admin/upload-pdf", {
    method: "POST",
    credentials: "include",
    body: fd
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || "Upload failed");
  return data;
}

// ── Contact submissions ─────────────────────────────────────────
export const adminGetContacts = () => request("/api/admin/contacts");
export const adminDeleteContact = (id) =>
  request(`/api/admin/contacts/${id}`, { method: "DELETE" });
